import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const key = (rd) => `orb-recorder-ready-dismissed-${rd.needed}`;

export const RecorderReadyBanner = ({ ready, onGoBacktest }) => {
  const [hidden, setHidden] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!ready?.ready || hidden || localStorage.getItem(key(ready))) return null;

  const run = async () => {
    setBusy(true);
    try {
      await api.post("/research/strategies", { pricing: "recorded", oos_pct: 30, kinds: ["orb", "bb_rsi_vwap"] });
      toast.success("Real-price Bollinger vs ORB comparison started");
      onGoBacktest();
      setTimeout(() => document.querySelector("[data-testid=panel-strategy-lab]")?.scrollIntoView({ behavior: "smooth", block: "start" }), 400);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const dismiss = () => { localStorage.setItem(key(ready), "1"); setHidden(true); };

  return (
    <div data-testid="banner-recorder-ready" className="flex flex-wrap items-center gap-2 border-t border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-xs text-emerald-300 sm:px-4">
      <Sparkles size={14} />
      <span><b>{ready.days} trading days of option prices recorded</b> ({ready.first_date} → {ready.last_date}). You can now backtest on real spread prices.</span>
      <span className="ml-auto flex items-center gap-3">
        <button data-testid="button-run-recorded-comparison" disabled={busy} onClick={run} className="font-semibold underline underline-offset-2 disabled:opacity-50">
          {busy ? "Starting…" : "Run Bollinger vs ORB on real prices"}
        </button>
        <button data-testid="button-dismiss-recorder-ready" onClick={dismiss} aria-label="Dismiss"><X size={13} /></button>
      </span>
    </div>
  );
};
